import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { UpdateHasClosedModal, UpdateIsElligible } from '@stores/feedback/feedback.actions';

interface FeedbackStateModel {
  feedbackCampaignStartDate: number;
  feedbackCampaignEndDate: number;
  isElligible: boolean;
  hasClosedModal: boolean;
}

@State({
  name: 'feedback',
  defaults: {
    feedbackCampaignStartDate: new Date('2021-04-24T07:00:00').getTime() / 1000,
    feedbackCampaignEndDate: new Date('2021-04-24T18:00:00').getTime() / 1000,
    isElligible: false,
    hasClosedModal: false,
  },
})
@Injectable()
export class FeedbackState {
  @Selector([FeedbackState, FeedbackState.isFeedbackCampaignUp])
  static isElligible(state: FeedbackStateModel, isFeedbackCampaignUp: boolean): boolean {
    return isFeedbackCampaignUp ? state.isElligible : isFeedbackCampaignUp;
  }

  @Selector([FeedbackState])
  static startDate(state: FeedbackStateModel): number {
    return state.feedbackCampaignStartDate;
  }

  @Selector([FeedbackState])
  static endDate(state: FeedbackStateModel): number {
    return state.feedbackCampaignEndDate;
  }

  @Selector([FeedbackState.startDate, FeedbackState.endDate])
  static isFeedbackCampaignUp(startDate: number, endDate: number): boolean {
    const date = Math.round(Date.now() / 1000);
    return date > startDate && date < endDate;
  }

  @Selector([FeedbackState])
  static hasClosedModal(state: FeedbackStateModel): boolean {
    return state.hasClosedModal;
  }

  @Action(UpdateIsElligible)
  updateIsElligible(ctx: StateContext<FeedbackStateModel>, { isElligible }: UpdateIsElligible): void {
    ctx.patchState({ isElligible });
  }

  @Action(UpdateHasClosedModal)
  updateHasClosedModal(ctx: StateContext<FeedbackStateModel>, { hasClosedModal }: UpdateHasClosedModal): void {
    ctx.patchState({ hasClosedModal });
  }
}
